//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.DrillToolBuilder.js";
let d=[[[0,"FormName",1,0],[0,"TlFormType",1,0]],[],[]];
SPLM.CAM.DrillThreadMillToolBuilder = class extends SPLM.CAM.DrillToolBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.DrillThreadMillToolBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.DrillThreadMillToolBuilder.ToolFormTypeTypes = Object.freeze({
    "Unified" : "Unified", "Metric" : "Metric", "Trapezoidal" : "Trapezoidal", "Acme" : "Acme", "Stubacme" : "Stubacme", "Lowenherz" : "Lowenherz", "Buttress" : "Buttress", "Sparkplug" : "Sparkplug", "Npt" : "Npt", "Hosecoupling" : "Hosecoupling", "Firehose" : "Firehose", "Unj" : "Unj", "Nps" : "Nps", "Bsp" : "Bsp", "Bstp" : "Bstp", "Helicoil" : "Helicoil", "Ns" : "Ns", "UserDefined" : "UserDefined", "PartialV60" : "PartialV60", "PartialV55" : "PartialV55"});

export default SPLM;